import React, { useEffect, useState } from 'react';
import "../Electrician/Electrician.css"
import { useNavigate } from "react-router-dom";
const Washing = ({ cart, addToCart }) => {
  const navigate = useNavigate();
  const [openService, setOpenService] = useState(null);
  const services = [
    {
      id: 401,
      title: "Full Deep Service (2 Machines)",
      price: 999,
      subtitle: "Drum deep clean • Filter cleaning • Bacteria removal",
      extra_detail_1: "Deep clean drum and internal parts",
      extra_detail_2: "Remove bacteria and bad odors",
      image: "https://s3-ap-southeast-1.amazonaws.com/urbanclap-prod/images/growth/luminosity/1744379110644-4825c5.jpeg"
    },
    {
      id: 402,
      title: "Jet Cleaning Service (2 Machines)",
      price: 1199,
      subtitle: "Removes dirt, bad smell & improves performance Professional Jet Wash + Interior cleaning",
      extra_detail_1: "High pressure jet cleaning service",
      extra_detail_2: "Removes dirt and improves performance",
      image: "https://s3-ap-southeast-1.amazonaws.com/urbanclap-prod/images/growth/luminosity/1744379110644-4825c5.jpeg"
    },
    {
      id: 403,
      title: "General Service",
      price: 399,
      subtitle: "External clean • Filter wash • Drum checkup",
      extra_detail_1: "Clean filters and machine exterior",
      extra_detail_2: "Check drum and basic functions",
      image: "https://www.urbancompany.com/img?bucket=urbanclap-prod&quality=90&format=auto/w_128,dpr_2,fl_progressive:steep,q_auto:low,f_auto,c_limit/images/supply/customer-app-supply/1710322857049-6cd763.jpeg"
    },
    {
      id: 404,
      title: "Full Deep Cleaning",
      price: 699,
      subtitle: "Recommended every 6 months Internal cleaning • Bacteria removal",
      extra_detail_1: "Complete internal drum cleaning service",
      extra_detail_2: "Removes bacteria and detergent residue",
      image: "https://5.imimg.com/data5/SELLER/Default/2025/8/536411164/HG/WD/IG/118748666/washing-machine-deep-cleaning-service-500x500.jpg"
    },
    {
      id: 405,
      title: "Machine Not Spinning",
      price: 249,
      subtitle: "Inspection & repair",
      extra_detail_1: "Fix spinning issues in washing machine",
      extra_detail_2: "Check motor belt and drum",
      image: "https://www.revampservice.com/web-assets/images/washing-machine-repair.jpg"
    },
    {
      id: 406,
      title: "Power / Start Problem",
      price: 299,
      subtitle: "Fix startup & shutdown issues",
      extra_detail_1: "Fix machine startup and power issues",
      extra_detail_2: "Check wiring switch and panel",
      image: "https://www.revampservice.com/web-assets/images/washing-machine-repair.jpg"
    },
    {
      id: 407,
      title: "Water Leakage Fix",
      price: 349,
      subtitle: "Fix leakage from pipe / drum",
      extra_detail_1: "Repair leakage from pipe or drum",
      extra_detail_2: "Ensure proper water flow sealing",
      image: "https://www.homeserve.co.uk/-/jssmedia/hs-living/data/media/wp-attachments/2021/04/how-do-i-fix-a-leaking-washing-machine.png"
    },
    {
      id: 408,
      title: "Noise / Vibration Issue",
      price: 299,
      subtitle: "Fix shaking or loud noise",
      extra_detail_1: "Fix unusual noise and vibrations",
      extra_detail_2: "Balance drum and tighten parts",
      image: "https://www.homeserve.co.uk/-/jssmedia/hs-living/data/media/wp-attachments/2021/04/how-do-i-fix-a-leaking-washing-machine.png"
    },
    {
      id: 409,
      title: "Error Code Repair",
      price: 349,
      subtitle: "Digital panel warning fix",
      extra_detail_1: "Diagnose and fix error codes",
      extra_detail_2: "Restore normal washing machine operation",
      image: "https://www.homeserve.co.uk/-/jssmedia/hs-living/data/media/wp-attachments/2021/04/how-do-i-fix-a-leaking-washing-machine.png"
    },
    {
      id: 410,
      title: "Installation",
      price: 799,
      subtitle: "Proper setup + balancing + demo",
      extra_detail_1: "Install washing machine safely",
      extra_detail_2: "Ensure proper setup and balancing",
      image: "https://www.homeserve.co.uk/-/jssmedia/hs-living/data/media/wp-attachments/2021/04/how-do-i-fix-a-leaking-washing-machine.png"
    },
    {
      id: 411,
      title: "Uninstallation",
      price: 499,
      subtitle: "Safe removal",
      extra_detail_1: "Remove washing machine safely",
      extra_detail_2: "Disconnect pipes and power properly",
      image: "https://www.homeserve.co.uk/-/jssmedia/hs-living/data/media/wp-attachments/2021/04/how-do-i-fix-a-leaking-washing-machine.png"
    }
  ]
  return (
    <div className='container-fluid service-electrician'>
      <div id="Electronic">
        <h1>Washing Machine Servcies</h1>
      </div>
      <div className='elect-container'>
        <div className="services-section-elect">
          {services.map((service) => {
            const isAdded = cart.some(
              item => item.id === service.id && item.category === service.category
            );
            return (
              <div key={service.id} className="service-card-elect">

                <div className="service-details-elect">
                  <h3>{service.title}</h3>

                  <div className="price-section-elect">
                    <span className="new-price-elect">₹{service.price}</span>
                  </div>
                  <button
                    className=" btn btn-link view-details-elect"
                    onClick={() =>
                      setOpenService(openService === service.id ? null : service.id)
                    }
                  >
                    View Details
                  </button>
                  {openService === service.id && (
                    <div className="extra-details-elect">
                      <p>✔ {service.extra_detail_1}</p>
                      <p>✔ {service.extra_detail_2}</p>
                    </div>
                  )}
                  <ul>
                    <li>{service.subtitle}</li>
                  </ul>
                </div>

                <div className="service-image-elect">
                  <img src={service.image} alt="" /><br />
                  <button
                    onClick={() => addToCart(service)}
                    className={`btn px-5 mt-2 ${isAdded ? "btn-success" : "btn-warning"
                      }`}
                  >
                    {isAdded ? "Added" : "Add"}
                  </button>
                </div>

              </div>
            );
          })}
        </div>
      </div>
    </div>
  )
}

export default Washing